/************
 * Developed by : Shiva Software Solutions
 * Date : 18-10-2022
 * Descriptions : Route page for erx upload page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const searchPatientConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/searchPatient',
        component: React.lazy(() => import('./searchPatient')),
      },
    ],
  },
];
